import { RootStoreContext } from '../hooks/useStore.hook';
import { AIStoreMobX } from './ai.store';
import { DialogStoreMobX } from './dialog.store';
import { GQLStoreMobX } from './gql.store';
import { I18NStoreMobX } from './i18n.store';
import { MapsStoreMobX } from './maps.store';
import { NotificationStoreMobX } from './notification.store';
import { SocketStoreMobX } from './socket.store';
import { SSOStoreMobX } from './sso.store';

export class RootStoreMobX {
  SSOStore: SSOStoreMobX;
  GQLStore: GQLStoreMobX;
  I18NStore: I18NStoreMobX;
  NotificationStore: NotificationStoreMobX;
  SocketStore: SocketStoreMobX;
  MapsStore: MapsStoreMobX;
  DialogStore: DialogStoreMobX;
  AIStore: AIStoreMobX;

  constructor() {
    this.SSOStore = new SSOStoreMobX(this);
    this.GQLStore = new GQLStoreMobX(this);
    this.I18NStore = new I18NStoreMobX(this);
    this.NotificationStore = new NotificationStoreMobX(this);
    this.SocketStore = new SocketStoreMobX(this);
    this.MapsStore = new MapsStoreMobX(this);
    this.DialogStore = new DialogStoreMobX(this);
    this.AIStore = new AIStoreMobX(this);
  }
}

export const RootStore: RootStoreMobX = new RootStoreMobX();

export const ConfigRoot = ({ children }: { children: React.ReactNode }) => {
  return (
    <RootStoreContext.Provider value={RootStore ?? new RootStoreMobX()}>
      {children}
    </RootStoreContext.Provider>
  );
};
